<template>
  <Dialog :commonDialog="dialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex>Manage Delivery Methods</v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createDeliveryMethod"
          >
            <span class="font-size-16 font-weight-600">Add Delivery Method</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="deliveryMethodForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateDeliveryMethods"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr
                      v-for="(method, index) in deliveryMethodList"
                      :key="index"
                    >
                      <td>
                        <v-text-field
                          v-model.trim="method.text"
                          dense
                          filled
                          placeholder="Enter Delivery Method"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :rules="[
                            validateRules.required(method.text, 'Delivery Method'),
                          ]"
                          color="cyan"
                        />
                      </td>
                      <td width="50" v-if="deliveryMethodList.length > 1">
                        <v-icon
                          color="deep-orange"
                          v-on:click="deleteDeliveryMethod(index)"
                        >mdi-delete</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateDeliveryMethods"
      >Save</v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >Close</v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { GET, PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    delivery_methods: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    delivery_methods: {
      deep: true,
      immediate: true,
      handler(param) {
        this.deliveryMethodList = cloneDeep(param);
      },
    },
  },
  data: () => ({
    formValid: true,
    pageLoading: false,
    deliveryMethodList: [],
  }),
  methods: {
    getDeliveryMethods() {
      this.pageLoading = true;
      this.$store
        .dispatch(GET, { url: "setting/delivery-methods" })
        .then((response) => {
          const list = response?.data?.delivery_methods || [];
          this.deliveryMethodList = cloneDeep(list);
          this.$emit("get-delivery-methods", cloneDeep(list));
        })
        .catch((error) => this.logError(error))
        .finally(() => {
          this.pageLoading = false;
        });
    },
    updateDeliveryMethods() {
      const formErrors = this.validateForm(this.$refs.deliveryMethodForm);
      if (formErrors.length || !this.$refs.deliveryMethodForm.validate()) {
        formErrors.forEach((error) =>
          ErrorEventBus.$emit("update:error", InitializeError(error))
        );
        return false;
      }

      this.pageLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "setting/delivery-methods",
          data: { delivery_method: this.deliveryMethodList },
        })
        .then(() => {
          this.$emit("close-dialog", true);
          this.getDeliveryMethods();
        })
        .catch((error) => this.logError(error))
        .finally(() => {
          this.pageLoading = false;
        });
    },
    createDeliveryMethod() {
      this.deliveryMethodList.push({ text: "" });
    },
    deleteDeliveryMethod(index) {
      if (this.deliveryMethodList.length > 1) {
        this.deliveryMethodList.splice(index, 1);
      }
    },
  },
  components: { Dialog },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
